export const getVisualViewPortWidth = (): number => {
  // @ts-ignore
  if (window.visualViewport) {
    // @ts-ignore
    return window.visualViewport.width
  }
  return document.body.clientWidth
}
